import React, { RefObject } from "react";

import { PaneFooter } from "src/app/components/Pane/PaneTopbar/PaneTopbar";
import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { ReactComponent as ThunderIcon } from "src/images/thunder-move.svg";
import { ReactComponent as CloseIcon } from "src/images/close.svg";
import Loader from "./Loader";

interface CreateNewProjectPaneFooterProps {
  handleClosePane: () => void;
  isCreatingProject: boolean;
  submitProjectSetup: () => void;
  createCampaignButtonDisabled: boolean;
  buttonRef: RefObject<HTMLButtonElement>;
}

export default function CreateNewProjectPaneFooter({
  handleClosePane,
  isCreatingProject,
  submitProjectSetup,
  createCampaignButtonDisabled,
  buttonRef,
}: CreateNewProjectPaneFooterProps) {
  return (
    <PaneFooter>
      <div className="create-new-project-pane__buttons">
        <Button
          size="medium"
          variant="white-with-light-grey-border"
          onClick={handleClosePane}
          dataQa="close-create-new-project-pane-button"
        >
          <CloseIcon />
          <IDHFormattedMessage id="ws_close" defaultMessage="Close" />
        </Button>

        {isCreatingProject ? (
          <Loader />
        ) : (
          <Button
            size="medium"
            variant="blue"
            onClick={submitProjectSetup}
            disabled={createCampaignButtonDisabled}
            buttonRef={buttonRef}
            dataQa="create-new-project-button"
          >
            <ThunderIcon />
            <IDHFormattedMessage
              id="ws_create_campaign"
              defaultMessage="Create campaign"
            />
          </Button>
        )}
      </div>
    </PaneFooter>
  );
}
